import ActionsCellComponent from './ActionsCell';
import ActionsDownloadCellComponent from './ActionsDownloadCell';
import ContentCellComponent from './ContentCell';
import CreatedAtCellComponent from './CreatedAtCell';
import FormatCellComponent from './FormatCell';
import FrequencyCellComponent from './FrequencyCell';
import NextDeliveryCellComponent from './NextDeliveryCell';
import PeriodCellComponent from './PeriodCell';
import RecipientCellComponent from './RecipientCell';
import TitleCellComponent from './TitleCell';
import TypeCellComponent from './TypeCell';

export const ActionsCell = ActionsCellComponent;
export const ActionsDownloadCell = ActionsDownloadCellComponent;
export const CreatedAtCell = CreatedAtCellComponent;
export const FormatCell = FormatCellComponent;
export const FrequencyCell = FrequencyCellComponent;
export const NextDeliveryCell = NextDeliveryCellComponent;
export const PeriodCell = PeriodCellComponent;
export const RecipientCell = RecipientCellComponent;
export const ContentCell = ContentCellComponent;
export const TypeCell = TypeCellComponent;
export const TitleCell = TitleCellComponent;
